import fetchAPI from '../fetchAPI';

export const callCreateBillingAccount = async (data: any): Promise<iResponse<BillingAccount>> => {
  const response: iResponse<BillingAccount> = await fetchAPI({
    method: `POST`,
    route: `billing-accounts`,
    data
  });

  return response;
};

export default callCreateBillingAccount;
